/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendedbadge2Inputs */

const en_actionendedbadge2 = /** @type {(inputs: Actionendedbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

const de_actionendedbadge2 = /** @type {(inputs: Actionendedbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet`)
};

/**
* | output |
* | --- |
* | "Ended" |
*
* @param {Actionendedbadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendedbadge2 = /** @type {((inputs?: Actionendedbadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendedbadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendedbadge2(inputs)
	return de_actionendedbadge2(inputs)
});
export { actionendedbadge2 as "actionEndedBadge" }